import { useIdCardFileDownloadMutation } from "@app/store/reducers/configs/idCardFileUpload.api"

export function FileDownload({ fileId, title }: { fileId: string, title: string }) {
  const [downloadFile] = useIdCardFileDownloadMutation()

  const getName = (headers: Record<string, string>, defName = 'download') => {
    const cd = headers['content-disposition']

    if (cd) {
      const m =
        /filename\*?=(?:UTF-8''|")(.*?)(?:\"|$)/i.exec(cd) ||
        /filename="?([^"]+)"?/i.exec(cd)
      if (m?.[1])
        try {
          return decodeURIComponent(m[1])
        } catch {
          return m[1]
        }
    }
    return defName
  }

  const onDownload = async (fileId) => {
    try {
      const { blob, headers } = await downloadFile({ fileId }).unwrap()

      const contentType = headers['content-type'] || 'application/octet-stream'

      const filename = getName(
        headers,
        contentType.startsWith('image/') ? 'image' : 'file'
      )

      const blobUrl = URL.createObjectURL(
        new Blob([blob], { type: contentType })
      )
      const a = document.createElement('a')
      a.href = blobUrl
      a.download = filename
      document.body.appendChild(a)
      a.click()
      a.remove()
      URL.revokeObjectURL(blobUrl)
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <a
      style={{ color: '#015CD1', textDecoration: 'underline' }}
      onClick={() => onDownload(fileId)}
    >{title}</a>
  )
}